import { Injectable } from '@nestjs/common';
import { VehicleAssignment } from '../vehicle-assignment.entity';
import { VehicleAssignmentDto } from './vehicle-assignment.dto';
let moment = require('moment');
@Injectable()
export class VehicleAssignmentAdapter {
  
  public convertDtoToEntity(  vehicleAssignmentDto: VehicleAssignmentDto,  isUpdate: boolean = false ): VehicleAssignment {
    const vehicleAssignment = new VehicleAssignment();

    vehicleAssignment.vehicleAssignId=vehicleAssignmentDto.vehicleAssignId;
    // vehicleAssignment.vehicleNo=vehicleAssignmentDto.vehicleNo;
    vehicleAssignment.driverId=vehicleAssignmentDto.driverId;
    vehicleAssignment.harvestingDate=moment(vehicleAssignmentDto.harvestingDate).format('YYYY-MM-DD');
    vehicleAssignment.harvestingTime=vehicleAssignmentDto.harvestingTime;
    vehicleAssignment.assignedDate= new Date();
    vehicleAssignment.indentId=vehicleAssignmentDto.indentId;
    vehicleAssignment.isActive=vehicleAssignmentDto.isActive==undefined?true:vehicleAssignmentDto.isActive;
    vehicleAssignment.driverName = vehicleAssignmentDto.driverName
    vehicleAssignment.vehicleType = vehicleAssignmentDto.vehicleType
    vehicleAssignment.iceFactory = vehicleAssignmentDto.iceFactory
    vehicleAssignment.iceQuantity = vehicleAssignmentDto.iceQuantity
    vehicleAssignment.iceType = vehicleAssignmentDto.iceType

    if (isUpdate) {
      vehicleAssignment.updatedUser = vehicleAssignmentDto.updatedUser;
    } else {
      vehicleAssignment.isActive = true;
      vehicleAssignment.createdUser = vehicleAssignmentDto.createdUser;
    }
   return vehicleAssignment;
  }
  public convertEntityToDto(vehAssignmentObject: VehicleAssignment): VehicleAssignmentDto {
    const vehicleAssignmentDto= new VehicleAssignmentDto;
    vehicleAssignmentDto.vehicleAssignId = vehAssignmentObject.vehicleAssignId;
    // vehicleAssignmentDto.vehicleNo = vehAssignmentObject.vehicleNo;
    vehicleAssignmentDto.driverId = vehAssignmentObject.driverId;
    vehicleAssignmentDto.harvestingTime = vehAssignmentObject.harvestingTime;
    vehicleAssignmentDto.harvestingDate = vehAssignmentObject.harvestingDate;
    vehicleAssignmentDto.indentId = vehAssignmentObject.indentId;
    vehicleAssignmentDto.assignedDate = vehAssignmentObject.assignedDate;
    vehicleAssignmentDto.isActive = vehAssignmentObject.isActive;
    vehicleAssignmentDto.createdAt = vehAssignmentObject.createdAt;
    vehicleAssignmentDto.updatedAt = vehAssignmentObject.updatedAt;
    vehicleAssignmentDto.createdUser = vehAssignmentObject.createdUser;
    vehicleAssignmentDto.updatedUser = vehAssignmentObject.updatedUser;
    vehicleAssignmentDto.versionFlag = vehAssignmentObject.versionFlag;
    vehicleAssignmentDto.driverName = vehAssignmentObject.driverName;
    vehicleAssignmentDto.iceFactory = vehAssignmentObject.iceFactory;
    vehicleAssignmentDto.vehicleType = vehAssignmentObject.vehicleType;
    vehicleAssignmentDto.iceQuantity = vehAssignmentObject.iceQuantity;
    vehicleAssignmentDto.iceType = vehAssignmentObject.iceType;

    return vehicleAssignmentDto;
  }
}
